import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BlogPage from "../pages/blog/page";
import ArticlePage from "../pages/blog/ArticlePage";
import IndustriesPage from "../pages/industries/page";
import DentalPage from "../pages/dental/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/industrias",
    element: <IndustriesPage />,
  },
  {
    // Página especializada: InnoFlex Odontología
    path: "/odontologia",
    element: <DentalPage />,
  },
  {
    // Alias por si se enlaza siguiendo el patrón /industrias/<sector>.
    // Redirige en vez de renderizar para que las rutas relativas de los
    // assets (import.meta.env.BASE_URL) siempre resuelvan desde la raíz.
    path: "/industrias/odontologia",
    element: <Navigate to="/odontologia" replace />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/blog/:slug",
    element: <ArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
